const SEPARATOR = '>';

export const getProductAndToolKey = (productKey: string, toolKey: string) =>
  `${productKey}${SEPARATOR}${toolKey}`;

export const parseProductAndToolKey = (productAndToolKey: string) => {
  const [productId, toolId] = productAndToolKey.split(SEPARATOR);
  return { productId, toolId };
};

export const hasToolKey = (productAndToolKey: string) => {
  return productAndToolKey.includes('>');
};
